// extracted by mini-css-extract-plugin
export default {"no-data":"styles_no-data__ndyAJ"};